import { render, staticRenderFns } from "./IvBagPanel.vue?vue&type=template&id=e993d0ca&scoped=true&"
import script from "./IvBagPanel.vue?vue&type=script&lang=js&"
export * from "./IvBagPanel.vue?vue&type=script&lang=js&"
import style0 from "./IvBagPanel.vue?vue&type=style&index=0&id=e993d0ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e993d0ca",
  null
  
)

export default component.exports